<template>
    <div class="p-3 toggle-row">
        <strong>Мероприятия по текущей заявке</strong>
        <b-card>
            <div v-if="!loading && !failedLoading">
                <table class="table table-condensed table-striped table-borderless">
                    <thead>
                        <tr>
                            <th>Выполнено</th>
                            <th>Мероприятие</th>
                            <th>Выполнил</th>
                            <th>Заявка</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(event, i) in events">
                            <td class="w-auto">
                                <span class="d-flex flex-column">
                                    <span>{{ getExecutionDate(event) }}</span>
                                    <span class="text-secondary">{{ getExecutionTime(event) }}</span>
                                </span>
                            </td>
                            <td>
                                <span class="d-flex flex-column">
                                    <span><b-link :to="{ name: 'eventDetail', params: { id: event['id'] } }">{{ event['kind_name'] }}</b-link></span>
                                    <span class="text-secondary">№{{ event['id'] }}</span>
                                </span>
                            </td>
                            <td>
                                <span class="d-flex flex-column">
                                    <span>{{ event['executor_contract_object']['contractor_object']['name'] }}</span>
                                    <span class="text-secondary">Контракт №{{ event['executor_contract_object']['number'] }}</span>
                                </span>
                            </td>
                            <td>
                                <span v-if="event['request_object']">
                                    <b-link :to="{ name: 'requestsDetail', params: { id: event['request_object']['id'] } }">№{{ event['request_object']['id'] }}</b-link>
                                </span>
                                <span v-else>&mdash;</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div v-else-if="!loading">
                <div class="d-flex align-items-center p-2">
                    <span class="text-danger">Не удалось загрузить данные</span>
                </div>
            </div>
            <div v-else>
                <div class="d-flex align-items-center p-2">
                   <b-spinner />
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import api from "@/api";
import httpClient from "@/http";
import EventBus from "@/bus";

export default {
    name: "AnimalToggleRow",
    props: {
        objectId: { type: Number },
        object: { type: Object, default: () => { return {} } }
    },
    data() {
        return {
            loading: false,
            failedLoading: false,
            events: []
        }
    },
    computed: {
        url() {
            let filters = '';
            if (this.object['last_catching_event'] && this.object['last_catching_event']['request_object']) {
                filters += 'request=' + this.object['last_catching_event']['request_object']['id']
            }
            return api.animals.currentEvents.list(api.animals.default.detail(this.objectId)) + '?' + filters
        }
    },
    methods: {
        getExecutionDate(event) {
            return event['execution_date'].split(' ')[0]
        },
        getExecutionTime(event) {
            return event['execution_date'].split(' ')[1]
        },
        fetch() {
            const vm = this;
            vm.loading = true;
            vm.failedLoading = false;
            httpClient.get(vm.url)
                .then((response) => {
                    vm.events = response.data['results']
                }).catch(() => {
                    vm.failedLoading = true
                })
                .finally(() => {
                    vm.loading = false
                })
        }
    },
    mounted() {
        EventBus.$off('animal-toggle-row-' + this.objectId);
        EventBus.$on('animal-toggle-row-' + this.objectId, (data) => {
            if (data.animalId === this.objectId) {
                this.events = [];
                this.fetch()
            }
        })
    }
}
</script>

<style scoped>
.toggle-row {
    width: calc(100vw - 3.5rem);
}
</style>